export const queueViewEvents = {
    ITEM_COUNT_AT_OPEN: 'QueueViewItemCountAtOpen',
    ITEM_SELECTED: 'QueueViewItemSelected',
    COLUMNS_CHANGED: 'QueueViewColumnListChanged'
};

export const queueViewTabNames = {
    BOT: 'Bot',
    QUEUE: 'Queue',
    ASSIGNED: 'Assigned to Agent',
    CLOSED: 'Closed'
};

export const laneButtonsEvents = {
    CUSTOM_PRESSED: 'HeaderCustomPanelPressed',
    VISITOR_INFO_PRESSED: 'HeaderVisitorInfoPressed',
    CANNED_MESSAGES_PRESSED: 'HeaderCannedMessagesPressed',
    DISCUSSIONS_PRESSED: 'HeaderDiscussionPressed',
    SAVE_NEW_DEFAULT_LANE_VIEW: 'SaveNewDefaultLaneView',
    VISITOR_HISTORY_PRESSED: 'HeaderVisitorHistoryPressed'
};

export enum JoinChatEvents {
  JOIN = 'ChatJoined',
  LEAVE = 'ChatLeft'
}

export enum WorkViewEvents {
  SET_AUDIO = 'SetAudio'
}

export enum WorkViewEventValues {
  ON = 'on',
  OFF = 'off'
}

export enum WorkViewTaskTabEvents {
  ACTIVE_TAB_SELECTED = 'Task Column: Active tab selected',
  CLOSED_TAB_SELECTED = 'Task Column: Closed tab selected'
}

export enum WorkItemEvents {
  WORK_ITEM_SELECTED = 'WorkItemSelected',
  WORK_ITEM_ACCEPTED = 'WorkItemAccepted',
  COMPOSE_EMAIL = 'ComposeEmail'
}

export enum WorkItemEventParams {
  PANEL_COUNT = 'panel count',
  CANNED_MESSAGES_PANEL_VISIBLE = 'canned messages panel visible',
  SMART_ADVISOR_VISIBLE = 'smart advisor visible',
  CUSTOMER_INFO_VISIBLE = 'customer info visible',
  CUSTOM_TAB_VISIBLE = 'custom tab visible',
  UNREAD_MESSAGE_COUNT = 'unread message count',
  VISITOR_LANGUAGE = 'visitor language',
  QUICK_ACCEPT = 'quick accept',
  TYPE = 'type',
  FROM = 'from'
}

export enum WorkItemEventValues {
  BUTTON = 'Button'
}
